<div class="form-row" fxLayout="row" fxLayoutGap="2em" fxLayoutAlign="start center">
  <div *ngIf="!file || reloadDoc" class="custom-file">
    <input
      style="display: none"
      #myInput
      type="file"
      ng2FileSelect
      [uploader]="uploader"
      [accept]="validFormats.join()" />
    <button
      mat-raised-button
      [disabled]="disabledUploadButton || !canUpdate"
      color="primary"
      (click)="myInput.click(); onClick.emit()"
      [attr.aria-label]="reloadDoc ? 'Dokument ändern' : 'Dokument hochladen'">
      <mat-icon aria-hidden="true" style="margin-right: 0.25em">cloud_upload</mat-icon>
      <span *ngIf="!reloadDoc">Dokument hochladen</span>
      <span *ngIf="reloadDoc">Dokument ändern</span>
    </button>
  </div>

  <button
    mat-icon-button
    color="accent"
    *ngIf="file?.isError"
    (click)="retry()"
    aria-label="Erneut versuchen">
    <mat-icon>refresh</mat-icon>
  </button>

  <button mat-icon-button color="primary" *ngIf="file?.isError" (click)="reset()" aria-label="Abbrechen">
    <mat-icon>close</mat-icon>
  </button>

  <!-- <div>DEBUG: {{ group.value | json }}</div> -->
</div>
<div *ngIf="file?.isError" class="error">{{ errorMessage }}</div>
<div *ngIf="showFileName && file && documentDto">
  <div fxLayout="row" fxFlexAlign="stretch" style="align-items: baseline">
    <button mat-icon-button color="warn" *ngIf="canUpdate" (click)="deleteFile()" aria-label="Datei löschen">
      <mat-icon>close</mat-icon>
    </button>
    <p>
      <strong>Dokument hochgeladen:</strong>
      {{ documentDto.fileName }}
    </p>
  </div>
</div>
<mat-progress-bar mode="indeterminate" *ngIf="isBusy"></mat-progress-bar>
